import React, { Component } from "react";
import "./Skills.scss";
import { 
  trackSectionView, 
  trackSkillHover, 
  trackTimeOnSection,
  trackSkillsView 
} from "../utils/analytics";

class Skills extends Component {
  constructor(props) {
    super(props);
    this.sectionRef = React.createRef();
    this.sectionStartTime = null;
    this.hasTrackedView = false;
  }

  componentDidMount() {
    this.setupIntersectionObserver();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.trackTimeSpent();
  }

  setupIntersectionObserver = () => {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.sectionStartTime = Date.now();
            if (!this.hasTrackedView) {
              trackSectionView('skills');
              trackSkillsView();
              this.hasTrackedView = true;
            }
          } else {
            this.trackTimeSpent();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (this.sectionRef.current) {
      this.observer.observe(this.sectionRef.current);
    }
  };

  trackTimeSpent = () => {
    if (this.sectionStartTime) {
      const timeSpent = Math.round((Date.now() - this.sectionStartTime) / 1000);
      if (timeSpent > 1) {
        trackTimeOnSection('skills', timeSpent);
      }
      this.sectionStartTime = null;
    }
  };

  handleSkillHover = (skillName, skillCategory) => {
    trackSkillHover(skillName, skillCategory);
  };
  render() {
    if (this.props.sharedSkills && this.props.resumeBasicInfo) {
      var sectionName = this.props.resumeBasicInfo.section_name.skills;
      var skills = this.props.sharedSkills.icons.map((skills, i) => {
        return (
          <div 
            className="skill-card" 
            key={i}
            onMouseEnter={() => this.handleSkillHover(skills.name, skills.category || 'general')}
          >
            <div className="skill-icon-wrapper">
              <i className={skills.class} />
            </div>
            <div className="skill-info">
              <h3 className="skill-name">{skills.name}</h3>
              <div className="skill-level">
                <div className="skill-progress">
                  <div className="skill-progress-bar"></div>
                </div>
              </div>
            </div>
            <div className="skill-overlay"></div>
          </div>
        );
      });
    }

    return (
      <section className="skills-section" id="skills" ref={this.sectionRef}>
        <div className="container">
          <div className="skills-header">
            <h2 className="section-title">{sectionName}</h2>
            <div className="section-divider"></div>
            <p className="section-subtitle">
              Technologies and tools I work with to create amazing experiences
            </p>
          </div>
          
          <div className="skills-grid">
            {skills}
          </div>
          
          <div className="skills-categories">
            <div className="category-card">
              <div className="category-icon">🎨</div>
              <h3>Frontend</h3>
              <p>ReactJs, NextJs, HTML5, CSS3, JavaScript</p>
            </div>
            
            <div className="category-card">
              <div className="category-icon">⚙️</div>
              <h3>Backend</h3>
              <p>NodeJs, Express, MongoDB, MySQL, PostgreSQL</p>
            </div>
            
            <div className="category-card">
              <div className="category-icon">📱</div>
              <h3>Mobile</h3>
              <p>React Native, Flutter, iOS, Android</p>
            </div>
            
            <div className="category-card">
              <div className="category-icon">☁️</div>
              <h3>Cloud & DevOps</h3>
              <p>AWS, Docker, Kubernetes, CI/CD</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Skills;
